import { Trash2 } from "lucide-react";
import { ConfirmButton } from "./AdminShared";

export default function CommunitiesTab({ communities, onDelete }) {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
      {communities.map((c) => (
        <div key={c.id} data-testid={`admin-community-${c.id}`} className="card-surface p-5">
          <div className="font-display text-xl mb-1">{c.name}</div>
          <div className="text-sm text-zinc-400 mb-2 line-clamp-2">{c.description}</div>
          <div className="text-xs text-zinc-500 mb-3">{c.members_count.toLocaleString()} members</div>
          <ConfirmButton
            testid={`admin-community-${c.id}-delete`}
            variant="danger"
            label="Delete community?"
            description="All posts in it will become public feed posts. Memberships are removed."
            onConfirm={() => onDelete(c.id)}
          >
            <Trash2 size={13} /> Delete
          </ConfirmButton>
        </div>
      ))}
    </div>
  );
}
